export enum TabsDenialsEnum {
    Details = 1,
    Eligibility = 2
}



// WEBPACK FOOTER //
// ./src/app/core/enums/tabs-denials-enum.ts